import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Pluralize from 'react-pluralize';
import { createModal } from 'react-modal-promise';
import { Typeahead } from 'react-bootstrap-typeahead';

function BulkAccessoryEditModal({
  accessoryConfig,
  close,
  selected,
  updateConfig,
  setBulkEdit,
}) {
  const [categoryIds, setCategoryIds] = useState([]);
  const [enabled, setEnabled] = useState(false);
  const [taxed, setTaxed] = useState(false);

  const accessories = (accessoryConfig || {}).accessories || [];
  const categories = (accessoryConfig || {}).categories || [];

  const onSave = () => {
    const newAccessories = accessories.map(accessory => {
      if (selected.find(a => a.id === accessory.id) !== undefined) {
        accessory.taxed = taxed;
        accessory.enabled = enabled;
        accessory.categoryIds = categoryIds;
      }
      return accessory;
    });

    updateConfig({ accessories: newAccessories });
    setBulkEdit(false);
    close(true);
  };

  return (
    <div className="p-modal-container">
      <div className="p-modal accessory-modal">
        <h3>Bulk Edit Accessories</h3>
        <i
          onClick={() => close(false)}
          className="modal-close close icon"
          alt="close"
        />
        <div className="p-modal-body">
          <div className="row p-form">
            <div className="col-sm-6">
              <h4>
                <Pluralize
                  singular="Accessory"
                  plural="Accessories"
                  count={selected.length}
                />
              </h4>
              {selected.map(a => (
                <div className="accessory-list-item" key={a.id}>
                  {a.name}
                </div>
              ))}
            </div>
            <div className="col-sm-6">
              <h4>New Values</h4>
              <p>
                <i>
                  New Values will overwrite existing Values for all selected
                  Accessories.
                </i>
              </p>
              <div className="form-group">
                <label>Categories</label>
                <Typeahead
                  id="accessory-typeahead"
                  className="picker"
                  selectHintOnEnter
                  multiple
                  clearButton
                  labelKey="name"
                  options={categories}
                  selected={categories.filter(c => categoryIds.includes(c.id))}
                  onChange={values => setCategoryIds(values.map(c => c.id))}
                />
              </div>
              <div className="checkbox accessory-modal-checkbox">
                <label>
                  <input
                    type="checkbox"
                    name="enabled"
                    checked={enabled}
                    onChange={e => setEnabled(e.target.checked)}
                  />
                  Enable Accessory
                </label>
              </div>
              <div className="checkbox accessory-modal-checkbox">
                <label>
                  <input
                    type="checkbox"
                    name="taxed"
                    checked={taxed}
                    onChange={e => setTaxed(e.target.checked)}
                  />
                  Taxable
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="accessory-modal-footer">
          <button
            type="button"
            className="btn btn-default"
            onClick={() => close(false)}
          >
            Cancel
          </button>
          <button type="button" className="btn btn-primary" onClick={onSave}>
            Apply Changes
          </button>
        </div>
      </div>
    </div>
  );
}

BulkAccessoryEditModal.propTypes = {
  accessoryConfig: PropTypes.object,
  close: PropTypes.func,
  updateConfig: PropTypes.func,
  setBulkEdit: PropTypes.func,
  selected: PropTypes.array,
};

export default createModal(BulkAccessoryEditModal);
